module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_6000.89b98202.png";